import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { EstoqueMadeira } from '../../types/aquisicao';
import { estoqueMadeiraService } from '../../services';

const columns: ResourceColumn<EstoqueMadeira>[] = [
  { header: 'Lote', accessor: 'lote_info' },
  { header: 'Disponível (ton)', accessor: 'quantidade_disponivel' },
  { header: 'Em tratamento (ton)', accessor: 'quantidade_em_tratamento' },
  { header: 'Tratada (ton)', accessor: 'quantidade_tratada' },
  { header: 'Localização', accessor: 'localizacao' },
];

export const EstoqueMadeiraListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Estoque de madeira"
      description="Saldo disponível por lote."
      columns={columns}
      service={estoqueMadeiraService}
      createPath="/admin/aquisicao/estoque-madeira/novo"
      onEdit={(item) =>
        item.id &&
        navigate('/admin/aquisicao/estoque-madeira/editar', { state: { record: item } })
      }
      onDelete={(item) => (item.id ? estoqueMadeiraService.remove(item.id) : Promise.resolve())}
    />
  );
};
